import {defineMessages} from 'react-intl';

export default defineMessages({
	returnCheckboxLabel: {
		id: 'returnAuthCreateForm.step1.returnCheckboxLabel',
		defaultMessage: 'Return?',
	},
});